









































































import Vue from "vue";
export default Vue.extend({
  computed: {
    courses() {
      return this.$store.state.courses;
    }
  },
  mounted() {
    this.$store.dispatch("loadCourses");
  }
});
